/* @jsxImportSource react */

import type { FC } from 'react';
import { SWRConfig } from 'swr';

import config from '@packages/config';
import type { Locale } from '@packages/config';
import type { Device } from '@packages/shared/src/utils/types';
import { ResponsiveNavigationLoaderClient } from './ResponsiveNavigationLoader.Client';
import { getNavigationDataEndpoint } from '../getNavigationDataEndpoint';
import { fetchRequiredStaticJson } from '../../api';

/**
 * RSC data fetching wrapper around {@link ResponsiveNavigationLoaderClient}
 */
export const ResponsiveNavigationLoaderServer: FC<{ device: Device; locale: Locale }> = async ({
  locale,
  device,
}) => {
  const {
    clientId,
    navigation: { loadSliced },
  } = config;

  const navEndpoint = getNavigationDataEndpoint(
    clientId,
    device === 'desktop' ? 'web' : 'mob',
    locale,
    loadSliced,
  );

  const data = await fetchRequiredStaticJson(navEndpoint, {
    componentName: 'ResponsiveNavigationLoaderServer',
  });

  return (
    <SWRConfig value={{ fallback: { [navEndpoint]: data } }}>
      <ResponsiveNavigationLoaderClient device={device} />
    </SWRConfig>
  );
};
